import Vue from 'vue'

export const websiteState = Vue.observable({
    pnList: []
})

export function setPnList(list) {
    websiteState.pnList = Array.isArray(list)
        ? list
        : []
}
